import ReportsExecute from './ReportsExecuteContainer';

export default ReportsExecute;

